"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyCustomerDataPersonalCouponToJSON = exports.ReadonlyCustomerDataPersonalCouponFromJSONTyped = exports.ReadonlyCustomerDataPersonalCouponFromJSON = void 0;
var runtime_1 = require("../runtime");
function ReadonlyCustomerDataPersonalCouponFromJSON(json) {
    return ReadonlyCustomerDataPersonalCouponFromJSONTyped(json, false);
}
exports.ReadonlyCustomerDataPersonalCouponFromJSON = ReadonlyCustomerDataPersonalCouponFromJSON;
function ReadonlyCustomerDataPersonalCouponFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !(0, runtime_1.exists)(json, 'code') ? undefined : json['code'],
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
        'conditionsText': !(0, runtime_1.exists)(json, 'conditionsText') ? undefined : json['conditionsText'],
    };
}
exports.ReadonlyCustomerDataPersonalCouponFromJSONTyped = ReadonlyCustomerDataPersonalCouponFromJSONTyped;
function ReadonlyCustomerDataPersonalCouponToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'text': value.text,
        'conditionsText': value.conditionsText,
    };
}
exports.ReadonlyCustomerDataPersonalCouponToJSON = ReadonlyCustomerDataPersonalCouponToJSON;
//# sourceMappingURL=ReadonlyCustomerDataPersonalCoupon.js.map